/* Delivery estimate — extracted from sections/main-product.liquid (Sep 2026).
   15KB of identical script inlined into every product page, with no Liquid in it.
   Now fetched once and cached; the block's settings still come from its markup. */
(function () {
  /* Re-entry guard: Dawn re-renders the section on variant change, but
     innerHTML-injected scripts never execute, so the first instance owns
     the ticker and re-queries the DOM on every tick. */
  if (window.MgbDeliveryEstimate) { window.MgbDeliveryEstimate.render(); return; }

  var SEL = '[data-mgb-delivery]';

  var UK_ZONES = { 'Europe/London': 1, 'Europe/Belfast': 1, 'GB': 1, 'GB-Eire': 1 };
  var US_ZONES = {
    'America/New_York': 1, 'America/Detroit': 1, 'America/Chicago': 1,
    'America/Denver': 1, 'America/Boise': 1, 'America/Phoenix': 1,
    'America/Los_Angeles': 1, 'America/Anchorage': 1, 'America/Juneau': 1,
    'America/Sitka': 1, 'America/Yakutat': 1, 'America/Nome': 1,
    'America/Adak': 1, 'America/Metlakatla': 1, 'America/Menominee': 1,
    'Pacific/Honolulu': 1, 'America/Puerto_Rico': 1
  };
  /* Sub-zones and legacy aliases. Deliberately NOT a bare 'America/' prefix,
     which would swallow Toronto, Mexico_City, Sao_Paulo, etc. */
  var US_PREFIXES = ['America/Indiana/', 'America/Kentucky/', 'America/North_Dakota/', 'US/'];

  var DAY_LONG  = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var DAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  var DAY_MS = 86400000;

  function zoneCountry(tz) {
    if (!tz) return '';
    if (UK_ZONES[tz]) return 'GB';
    if (US_ZONES[tz]) return 'US';
    for (var i = 0; i < US_PREFIXES.length; i++) {
      if (tz.indexOf(US_PREFIXES[i]) === 0) return 'US';
    }
    return '';
  }

  function browserZone() {
    try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; }
    catch (e) { return ''; }
  }

  /* Wall-clock reading of `date` in `tz`. Intl handles GMT/BST for us. */
  function wallClock(date, tz) {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', {
        timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      }).formatToParts(date).forEach(function (part) { p[part.type] = part.value; });
      return {
        y: +p.year, m: +p.month, d: +p.day,
        H: (+p.hour) % 24, M: +p.minute, S: +p.second
      };
    } catch (e) {
      return {
        y: date.getFullYear(), m: date.getMonth() + 1, d: date.getDate(),
        H: date.getHours(), M: date.getMinutes(), S: date.getSeconds()
      };
    }
  }

  /* Civil dates are held as UTC-midnight Dates so day arithmetic is DST-proof. */
  function civil(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }
  function addDays(dt, n) { return new Date(dt.getTime() + n * DAY_MS); }
  function ymd(dt) {
    return dt.getUTCFullYear() + '-' +
      ('0' + (dt.getUTCMonth() + 1)).slice(-2) + '-' +
      ('0' + dt.getUTCDate()).slice(-2);
  }
  function isOpen(dt, days, holidays) {
    return days.indexOf(dt.getUTCDay()) !== -1 && holidays.indexOf(ymd(dt)) === -1;
  }
  function nextOpen(dt, days, holidays) {
    var x = addDays(dt, 1), guard = 0;
    while (!isOpen(x, days, holidays) && guard++ < 60) x = addDays(x, 1);
    return x;
  }

  function intAttr(root, name, fallback) {
    var v = parseInt(root.getAttribute(name), 10);
    return isNaN(v) ? fallback : v;
  }
  function listAttr(root, name, fallback) {
    var raw = (root.getAttribute(name) || '').split(/[^0-9]+/);
    var out = [];
    for (var i = 0; i < raw.length; i++) {
      if (raw[i] !== '') out.push(parseInt(raw[i], 10));
    }
    return out.length ? out : fallback;
  }
  function holidayAttr(root) {
    var raw = (root.getAttribute('data-holidays') || '').split(/[\s,;]+/);
    var out = [];
    for (var i = 0; i < raw.length; i++) {
      if (/^\d{4}-\d{2}-\d{2}$/.test(raw[i])) out.push(raw[i]);
    }
    return out;
  }

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function formatRemaining(secs) {
    var h = Math.floor(secs / 3600);
    var m = Math.floor((secs % 3600) / 60);
    var s = secs % 60;
    if (h > 0) return h + 'h ' + pad2(m) + 'm';
    if (m > 0) return m + 'm ' + pad2(s) + 's';
    return s + 's';
  }

  function shortDate(dt) {
    return DAY_SHORT[dt.getUTCDay()] + ' ' + dt.getUTCDate() + ' ' + MON_SHORT[dt.getUTCMonth()];
  }

  /* Relative wording is measured against the CUSTOMER's local calendar day,
     not London's — a US shopper at 01:00 London is still on yesterday. */
  function relativeDate(target, todayLocal) {
    var diff = Math.round((target.getTime() - todayLocal.getTime()) / DAY_MS);
    if (diff === 0) return 'Today';
    if (diff === 1) return 'Tomorrow, ' + shortDate(target);
    return shortDate(target);
  }
  function relativeDay(target, todayLocal) {
    var diff = Math.round((target.getTime() - todayLocal.getTime()) / DAY_MS);
    if (diff === 0) return 'today';
    if (diff === 1) return 'tomorrow';
    if (diff > 1 && diff < 7) return DAY_LONG[target.getUTCDay()];
    return shortDate(target);
  }

  /* Replaces {time} / {day} / {date} with a bolded <span>. */
  function fillTemplate(el, template, tokens, valueClass) {
    while (el.firstChild) el.removeChild(el.firstChild);
    var re = /\{(time|day|date)\}/g, last = 0, match;
    while ((match = re.exec(template)) !== null) {
      if (match.index > last) {
        el.appendChild(document.createTextNode(template.slice(last, match.index)));
      }
      var span = document.createElement('span');
      span.className = 'mgb-delivery__value' + (valueClass ? ' ' + valueClass : '');
      span.textContent = tokens[match[1]] == null ? '' : tokens[match[1]];
      el.appendChild(span);
      last = match.index + match[0].length;
    }
    if (last < template.length) {
      el.appendChild(document.createTextNode(template.slice(last)));
    }
  }

  function resolveCountry(root) {
    var preview = (root.getAttribute('data-preview-country') || '').toUpperCase();
    if (preview) return preview;
    var fromZone = zoneCountry(browserZone());
    var fromShop = (root.getAttribute('data-shop-country') || '').toUpperCase();
    if (root.getAttribute('data-country-source') === 'market_first') {
      return fromShop || fromZone;
    }
    return fromZone || fromShop;
  }

  function renderOne(root, now) {
    var dispatchRow  = root.querySelector('[data-mgb-delivery-dispatch]');
    var dispatchText = root.querySelector('[data-mgb-delivery-dispatch-text]');
    var arrivalRow   = root.querySelector('[data-mgb-delivery-arrival]');
    var arrivalText  = root.querySelector('[data-mgb-delivery-arrival-text]');
    var note         = root.querySelector('[data-mgb-delivery-note]');
    if (!dispatchText || !arrivalText) return;

    /* Nothing to promise on a sold-out variant. */
    if (root.getAttribute('data-available') !== 'true') {
      root.hidden = true;
      root.classList.add('is-ready');
      return;
    }

    var country = resolveCountry(root);
    var isUK = country === 'GB';
    var isUS = country === 'US';
    var intlMode = root.getAttribute('data-intl-mode') || 'generic';

    if (!isUK && !isUS && intlMode === 'hide') {
      root.hidden = true;
      root.classList.add('is-ready');
      return;
    }
    root.hidden = false;

    /* UK and international ship on different cut-offs (shipping policy: 3pm UK,
       2pm international), so the countdown uses the one for where it's going. */
    var cutoffH      = isUK
      ? intAttr(root, 'data-cutoff-hour', 15)
      : intAttr(root, 'data-intl-cutoff-hour', intAttr(root, 'data-cutoff-hour', 15));
    var cutoffM      = intAttr(root, 'data-cutoff-minute', 0);
    var dispatchDays = listAttr(root, 'data-dispatch-days', [1, 2, 3, 4, 5]);
    var deliveryDays = listAttr(root, 'data-delivery-days', [1, 2, 3, 4, 5]);
    var holidays     = holidayAttr(root);

    var uk = wallClock(now, 'Europe/London');
    var todayUK = civil(uk.y, uk.m, uk.d);

    /* Pure wall-clock arithmetic. Safe across DST because the UK switches at
       01:00, always before a same-day 15:00 cutoff. */
    var secsLeft = (cutoffH * 3600 + cutoffM * 60) - (uk.H * 3600 + uk.M * 60 + uk.S);
    var shipsToday = isOpen(todayUK, dispatchDays, holidays) && secsLeft > 0;
    var dispatchDate = shipsToday ? todayUK : nextOpen(todayUK, dispatchDays, holidays);

    var transit = isUS
      ? intAttr(root, 'data-us-transit', 2)
      : intAttr(root, 'data-uk-transit', 1);
    var arrivalDate = dispatchDate;
    for (var i = 0; i < transit; i++) {
      arrivalDate = nextOpen(arrivalDate, deliveryDays, holidays);
    }

    var todayLocal = civil(now.getFullYear(), now.getMonth() + 1, now.getDate());

    if (shipsToday) {
      fillTemplate(
        dispatchText,
        root.getAttribute('data-text-before') || 'Order within {time} for dispatch today',
        { time: formatRemaining(secsLeft) },
        secsLeft < 3600 ? 'mgb-delivery__value--urgent' : ''
      );
    } else {
      fillTemplate(
        dispatchText,
        root.getAttribute('data-text-after') || 'Order now — dispatched {day}',
        { day: relativeDay(dispatchDate, todayLocal) },
        ''
      );
    }
    if (dispatchRow) dispatchRow.hidden = false;

    if (isUK || isUS) {
      fillTemplate(
        arrivalText,
        root.getAttribute('data-text-delivery') || 'Estimated delivery {date}',
        { date: relativeDate(arrivalDate, todayLocal) },
        ''
      );
      var noteText = isUS ? (root.getAttribute('data-note-us') || '') : '';
      if (note) {
        note.textContent = noteText;
        note.hidden = noteText === '';
      }
    } else {
      var intlText = root.getAttribute('data-text-delivery-intl') || '';
      fillTemplate(arrivalText, intlText, {}, '');
      if (note) { note.textContent = ''; note.hidden = true; }
      if (arrivalRow) arrivalRow.hidden = intlText === '';
    }

    root.classList.add('is-ready');
  }

  function render() {
    var nodes = document.querySelectorAll(SEL);
    if (!nodes.length) return;
    var now = new Date();
    for (var i = 0; i < nodes.length; i++) renderOne(nodes[i], now);
  }

  var scheduled = false;
  function scheduleRender() {
    if (scheduled) return;
    scheduled = true;
    var run = function () { scheduled = false; render(); };
    if (window.requestAnimationFrame) { window.requestAnimationFrame(run); }
    else { window.setTimeout(run, 0); }
  }

  window.MgbDeliveryEstimate = { render: render };

  render();
  setInterval(render, 1000);

  /* Dawn swaps the section's markup on variant change; repaint immediately
     rather than waiting up to a second for the next tick. */
  if (window.MutationObserver) {
    var first = document.querySelector(SEL);
    var host = (first && first.closest && first.closest('product-info')) || document.body;
    if (host) {
      new MutationObserver(scheduleRender).observe(host, { childList: true, subtree: true });
    }
  }

  document.addEventListener('shopify:section:load', scheduleRender);
  document.addEventListener('shopify:block:select', scheduleRender);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) render();
  });
})();
